<template>
  <v-tabs hide-slider active-class="elevation-10" grow>
    <v-tab>Devices</v-tab>
    <v-tab>Users</v-tab>
    <v-tab>Invitations</v-tab>
    <v-tab-item>
      <SubscriptionList
        has-search
        :subscriptions="subscriptionsData"
        :error="subscriptionsError"
        :loading="subscriptionsLoading"
      />
    </v-tab-item>
    <v-tab-item>
      <UserList
        has-search
        :with-navigation="true"
        :users="usersData"
        :loading="usersLoading"
        :error-message="usersError"
      />
    </v-tab-item>
    <v-tab-item>
      <InvitationListExpandable
        :invitations="invitationsData"
        :loading="invitationsLoading"
        :error="invitationsError">
      </InvitationListExpandable>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import SubscriptionList from '../components/SubscriptionList'
import UserList from '../components/UserList'
import InvitationListExpandable from './InvitationListExpandable'
export default {
  name: 'CustomerTabComponent',
  components: {
    SubscriptionList,
    UserList,
    InvitationListExpandable
  },
  computed: {
    subscriptionsData () {
      return this.$store.state.customer.allSubscriptions.data == null ? [] : this.$store.state.customer.allSubscriptions.data
    },
    subscriptionsError () {
      return this.$store.state.customer.allSubscriptions.error == null ? '' : this.$store.state.customer.allSubscriptions.error
    },
    subscriptionsLoading () {
      return this.$store.state.customer.allSubscriptions.data == null && this.$store.state.customer.allSubscriptions.error == null
    },
    usersData: function () {
      return this.$store.state.customer.allUsersWithSubscription.data === null ? [] : this.$store.state.customer.allUsersWithSubscription.data
    },
    usersError: function () {
      return this.$store.state.customer.allUsersWithSubscription.error === null ? '' : this.$store.state.customer.allUsersWithSubscription.error
    },
    usersLoading: function () {
      return this.$store.state.customer.allUsersWithSubscription.data === null && this.$store.state.customer.allUsersWithSubscription.error === null
    },
    invitationsData () {
      return this.$store.state.customer.allInvitations.data == null ? [] : this.$store.state.customer.allInvitations.data
    },
    invitationsError () {
      return this.$store.state.customer.allInvitations.error == null ? '' : this.$store.state.customer.allInvitations.error
    },
    invitationsLoading () {
      return this.$store.state.customer.allInvitations.data == null && this.$store.state.customer.allInvitations.error == null
    }
  }
}
</script>

<style scoped>

</style>
